<div class="order-summary">
  <div class="product-list">
    @for (row of rows; track $index) {
      <div class="product">
        <s-polaris-product-thumbnail
          [image]="row.thumbnail"
          [quantity]="row.quantity"
          [size]="40"></s-polaris-product-thumbnail>
        <div class="product__details">
          <span class="product__name">{{ row.name }}</span>
          <span class="product__variant">{{ row.variant }}</span>
          @if (row.tags.length) {
            <div class="product__tags">
              @for (tag of row.tags; track $index) {
                <span
                  class="tag"
                  [style.background-color]="tag.backgroundColor"
                  [style.color]="tag.textColor"
                  [style.border-radius.px]="tag.radiusPx">
                  {{ tag.label }}
                </span>
              }
            </div>
          }
        </div>
        <span class="product__price">{{ row.price }}</span>
      </div>
    }
  </div>

  <div class="totals">
    <div class="totals__row">
      <span>Subtotal · {{ totals.subtotalItems }} items</span>
      <span>{{ totals.subtotal }}</span>
    </div>
    <div class="totals__row">
      <span>Shipping</span>
      <span class="totals__muted">{{ totals.shipping }}</span>
    </div>
    <div class="totals__row totals__row--total">
      <span>Total</span>
      <span
        ><span class="totals__currency">{{ totals.currencyCode }}</span> {{ totals.total }}</span
      >
    </div>
  </div>
</div>
